import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "QuestionSquare",
  "use": "QuestionSquare-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" class=\"fizz-icon-24\" id=\"QuestionSquare\">\n  <path d=\"M25.3 4H6.7C5.2 4 4 5.2 4 6.7v18.7C4 26.8 5.2 28 6.7 28h18.7c1.5 0 2.7-1.2 2.7-2.7V6.7C28 5.2 26.8 4 25.3 4zM16 24c-.9 0-1.7-.7-1.7-1.7 0-.9.7-1.7 1.7-1.7.9 0 1.7.7 1.7 1.7 0 .9-.7 1.7-1.7 1.7zm4-9.9c-1 1.5-2 1.9-2.5 2.9-.2.4-.3.6-.3 1.9h-2.4c0-.7-.1-1.7.4-2.6.7-1.2 1.9-1.9 2.6-2.9.8-1.1.3-3.1-1.8-3.1-1.4 0-2.1 1.1-2.4 2l-2.2-.9C12 9.5 13.6 8 16 8c2 0 3.3.9 4 2 .6 1 .9 2.8 0 4.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol